import { render } from "./AddProjects.vue?vue&type=template&id=c4960962&scoped=true"
import script from "./AddProjects.vue?vue&type=script&lang=js"
export * from "./AddProjects.vue?vue&type=script&lang=js"

import "./AddProjects.vue?vue&type=style&index=0&id=c4960962&lang=scss&scoped=true"

import exportComponent from "E:\\myProjects\\myPortfolio\\my-portfolio-vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4960962"]])

export default __exports__